/**
 * Compose the document title fragment for an organization-scoped page.
 *
 * The page name is placed first so it remains visible when the browser
 * truncates the tab caption. `useDocumentTitle` then appends " - Kirin",
 * yielding "[Page] - [Org] - Kirin" (or "[Page] - Kirin" when the org
 * has not yet loaded).
 */
export function buildOrgDocumentTitle(
  currentPageTitle: string,
  organizationName: string | undefined
): string {
  return organizationName
    ? `${currentPageTitle} - ${organizationName}`
    : currentPageTitle;
}
